import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LEASE_DRAFT_GET_INFO } from 'api/actionTypes';

export default async function getDraftingInfo({ state, apiClient }, { householdListingId }) {
  typeCheck('householdListingId::PositiveNumber', householdListingId);

  const statePath = ['leases', 'draftInfo', householdListingId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LEASE_DRAFT_GET_INFO,
    state: state,
    payload: {
      householdListingId,
    },
    onSuccess(leaseDraftingInfo) {
      state.set(statePath, leaseDraftingInfo);
    },
  });
}
